
export const FETCH_BILL_ENTRY_REPORTS_ALL_DATA_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_ALL_DATA_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_ALL_DATA_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_ALL_DATA_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_ALL_DATA_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_ALL_DATA_FAILURE';

export const FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_FAILURE';

export const FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_REQUEST = 'FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_REQUEST';
export const FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_SUCCESS = 'FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_SUCCESS';
export const FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_FAILURE = 'FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_FAILURE';

export const FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_REQUEST = 'FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_REQUEST';
export const FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_SUCCESS = 'FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_SUCCESS';
export const FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_FAILURE = 'FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_FAILURE';


export const SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_ALL_DK = 'SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_ALL_DK';